<script setup lang="ts">
import type { HeaderCount } from '@/composables/headerCount'

const props = withDefaults(
  defineProps<{
    title: string
    count?: HeaderCount | null
    unitKey?: string | null
  }>(),
  { count: null, unitKey: null }
)

const { value: countValue, label: countLabel } = useHeaderCount(
  () => props.count,
  () => props.unitKey
)
</script>

<template>
  <div class="flex flex-col gap-4 px-6 pb-6 pt-6 sm:px-12 sm:pb-8 sm:pt-8 lg:flex-row lg:items-end lg:justify-between">
    <div class="flex min-w-0 items-center gap-3">
      <h1 class="truncate text-3xl font-bold tracking-tight text-foreground">{{ title }}</h1>
      <Badge v-if="countValue !== null" variant="neutral" class="shrink-0 text-sm" :title="countLabel ?? undefined">
        {{ countValue }}
      </Badge>
    </div>

    <div v-if="$slots.actions" class="flex shrink-0 items-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>
